<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div class="light-shade box rounded-corners" style="width: 100%; max-width: 440px">
      <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
        <div>Tickets Selected to Pay</div>
      </div>
      <div style="padding: 10px">
        <div style="padding: 10px">
          <table style="font-size: 14px; width: 100%">
            @for (item of ticketList; track item; let i = $index) {
              <tr>
                <td>
                  <div style="display: flex">
                    <div class="data-label">{{ ticketTypeName(item.ticket_type) }}:</div>
                    <div class="data-value">{{ item.ticket_number }}</div>
                  </div>
                </td>
                <td>
                  <div style="display: flex">
                    <div class="data-label">Balance Due:</div>
                    <div class="data-value">
                      {{ item.ticket_balance | currency: 'USD':'symbol' }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="display: flex">
                    <div class="data-label">Violation:</div>
                    <div class="data-value">{{ item.violation_code }} {{ item.violation_code_description }}</div>
                  </div>
                </td>
              </tr>
              @if (i + 1 !== ticketList.length) {
                <tr>
                  <td colspan="3">
                    <div style="border-bottom: 1px solid black; margin-bottom: 1px"></div>
                  </td>
                </tr>
              }
            }
          </table>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
